import {useTranslation} from "react-i18next";
import Divider from "antd/es/divider";
import React, {useEffect, useState} from "react";
import {List, Spin} from "antd";
import axios from "axios";


export default (prop) => {

    const { t } = useTranslation()

    const player = prop.player

    const [loading, setLoading] = useState(true)
    const [data, setData] = useState([
        {
            title: 'mmr',
        },
        {
            title: 'winStreak',
        },
        {
            title: 'loseStreak',
        },
        {
            title: 'kill',
        },
        {
            title: 'death',
        },
        {
            title: 'assist',
        },
        {
            title: 'matchInfo.money',
        },
        {
            title: 'matchInfo.damage',
        },
        {
            title: 'matchInfo.damaged',
        },
    ])

    useEffect(() => {

        axios.get(`player/max/${player.handle}`).then(res => {
            if (res) {
                data[0].value = player.mmrMax == -99999 ? t('noRank') : player.mmrMax
                data[1].value = player.winStreakMax
                data[2].value = player.loseStreakMax
                data[3].value = res.kill
                data[4].value = res.death
                data[5].value = res.assist
                data[6].value = res.money
                data[7].value = res.damage
                data[8].value = res.damaged
                setData([...data])
                setLoading(false)
            }
        })

    }, [])

    return (
        loading ? <Spin /> :
        <List
            itemLayout="horizontal"
            dataSource={data}
            renderItem={(item) => (
                <List.Item>
                    <List.Item.Meta title={<span>{t(item.title)}</span>}
                        description={
                            item.value !== undefined ?
                            <b style={{ fontSize: "20px" }}>{item.value}</b> : null
                        }
                    />
                </List.Item>
            )}
        />
    )

}
